import { render, staticRenderFns } from "./AppLayoutGridBlock.vue?vue&type=template&id=44716f2c&scoped=true"
import script from "./AppLayoutGridBlock.vue?vue&type=script&lang=js"
export * from "./AppLayoutGridBlock.vue?vue&type=script&lang=js"
import style0 from "./AppLayoutGridBlock.vue?vue&type=style&index=0&id=44716f2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44716f2c",
  null
  
)

export default component.exports